// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"Labels_cardHeader__1wJ_l","rightContent":"Labels_rightContent__1VJ6O","tagPillContainer":"Labels_tagPillContainer__1QLRY"};